/**
 * Calculator action buttons (Save, Share, Export)
 */
import { Stack } from '@mantine/core';
import { FeatureGate } from '../../../shared/components';
import { SaveCalculationDisabled } from '../../../shared/components/FeatureDisabledPage';
import { SaveCalculationSection, ShareCalculationSection, ExportCalculationSection } from './TariffCalculator';
import type { CalculatorFormValues, CalculationResults } from '../types/calculator.types';

interface CalculatorActionsProps {
  formValues: CalculatorFormValues | null;
  results: CalculationResults;
  isAuthenticated: boolean;
  onSave: () => void;
  saveStatus: 'idle' | 'saving' | 'success' | 'error';
  saveError: string | undefined;
  shareUrl: string | null;
  calculationYear: number;
}

export function CalculatorActions({
  formValues,
  results,
  isAuthenticated,
  onSave,
  saveStatus,
  saveError,
  shareUrl,
  calculationYear,
}: CalculatorActionsProps) {
  return (
    <Stack gap="md">
      {/* Save Calculation Section - Feature Toggle Gated */}
      <FeatureGate
        toggleId="save_calculation_enabled"
        defaultValue={true}
        fallback={<SaveCalculationDisabled />}
      >
        <div>
          <SaveCalculationSection
            calculationData={formValues!}
            calculationResults={results}
            onSave={onSave}
            isSaving={saveStatus === 'saving'}
            saveError={saveError}
            saveSuccess={saveStatus === 'success'}
            calculationExists={false}
          />
        </div>
      </FeatureGate>

      {/* Share Calculation Section - Feature Toggle Gated */}
      <FeatureGate
        toggleId="share_calculation_enabled"
        defaultValue={true}
      >
        <div>
          <ShareCalculationSection
            shareUrl={shareUrl}
            year={calculationYear}
          />
        </div>
      </FeatureGate>

      {/* CSV Export Section - Only for authenticated users */}
      {isAuthenticated && formValues && (
        <div>
          <ExportCalculationSection
            calculationData={{
              year: calculationYear,
              monthlyConsumption: formValues.monthlyConsumption,
              hourlyConfig: formValues.hourlyConfig || {
                weekday: Array(24).fill(1 / 24),
                weekend: Array(24).fill(1 / 24),
              },
            }}
          />
        </div>
      )}
    </Stack>
  );
}
